import React, { Component } from 'react';
import axios from 'axios';
import { API_HOST } from '../../consts';
import StackedAreaChart from '../../components/StackedAreaChart';
import ParticipacaoDreColumn from '../../components/ParticipacaoDreColumn';
import InsufficientData from '../../components/InsufficientData';
import { get } from 'lodash';
import { withTheme } from 'styled-components';
import LegendaStackedAreaGraph from './LegendaStackedAreaGraph';
import { BaseFiltroAvancadoItemStyleH1 } from './styles';
import FiltersPageStudent from '../avalia/FiltersPageAluno';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import ReportStudentSkillLevel from '../avalia/ReportStudentSkillLevel';
import { toast } from 'react-toastify';
import { GeneralStudentStyleButton } from '../avalia/style';
import GeneralStudentReport from '../avalia/GeneralStudentReport';
import FiltersPageStudentAvaliaMt from '../avalia/avaliaMtComponents/FiltersPageStudentAvaliaMt';
import { Container } from '@material-ui/core';

class ReportStudentAnalysis extends Component {
  state = {
    isLoading: true,
    boletimData: {},
    anoData: [],
    isTourOpen: true,
    metadata: undefined,
    isAvaliaMt: window.location.host.includes('avaliamt')
  };

  setBoletimData = (boletimData) => {
    this.setState({ boletimData });
  };

  componentWillUnmount() {
    this.state.isLoading = true;
  }

  buttonRelatorio = async (idn, periodoAno) => {
    this.setState({ isLoading: true });
    const { setStateFilters } = this.context;
    setStateFilters({
      currentStudent: idn,
      fecth: true,
      fecthRelatorioHabilidade: false,
      fecthRelatorioGeral: false
    });
    await this.fetchBoletimData(idn, periodoAno);
    await this.fetchMetadata();
    this.setState({ isLoading: false });
  };

  fetchBoletimData = async (idn, periodoAno) => {
    try {
      const response = await axios.get(
        `${API_HOST}/avalia/boletim_mt?idn=${idn}&PERIODO_ANO_ID__id=${periodoAno}`
      );
      this.setState({ boletimData: get(response.data, 'results')[0] });
      const ano = await this.fetchPeriodoData(periodoAno);
      await this.fetchAnoData(ano);
    } catch (error) {
      toast.error(error);
      this.setState({ responseStatus: error.response.status });
    }
  };

  fetchMetadata = async () => {
    const response = await axios.get(`${API_HOST}/params/param?name=Escala`);
    this.setState({ metadata: response.data[0].requireness });
  };

  fetchAnoData = async (ano) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/ano?id=${ano}`);
      this.setState({ anoData: response.data });
    } catch (error) {
      toast.error('Nenhum Ano/Data encontrado');
      console.error(error.message);
    }
  };

  fetchPeriodoData = async (periodo_ano_id) => {
    try {
      const response = await axios.get(
        `${API_HOST}/avalia/periodo_ano?id=${periodo_ano_id}`
      );
      this.setState({ periodoData: response.data[0] });
      return response.data[0].ano;
    } catch (error) {
      toast.error('Nenhum Ano/Data encontrado');
      console.error(error.message);
    }
  };

  render() {
    const { boletimData, isLoading, responseStatus, periodoData, metadata } =
      this.state;
    const { filtrosRelatorios, setStateFilters } = this.context;

    return (
      <Container
        style={{
          width: 'fit-content',
          background: '#fff',
          marginBottom: '5rem'
        }}
        maxWidth="lg"
      >
        <div
          style={{
            marginTop: '3rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div className="container mb-4">
            <div className="row">
              <div className="col-12">
                <div
                  className="card"
                  style={{
                    backgroundColor: '#f7f7f7',
                    borderRadius: '10px'
                  }}
                >
                  <div
                    className="card-header"
                    style={{
                      marginBottom: '-0.7rem',
                      backgroundColor: '#f7f7f7',
                      borderRadius: '10px'
                    }}
                  >
                    <h1
                      style={{
                        fontFamily: 'Quicksand',
                        fontSize: '24px',
                        color: '#292929',
                        fontWeight: 'bold'
                      }}
                    >
                      Relatório Individual
                    </h1>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#292929',
                        fontWeight: 500,
                        fontFamily: 'Quicksand'
                      }}
                    >
                      Notas e proficiência dos estudantes
                    </span>
                    <hr
                      style={{
                        background: '#bebebe',
                        width: '100%',
                        height: '1px',
                        borderRadius: '1px'
                      }}
                    />
                  </div>
                  <div
                    className="card-body"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    <FiltersPageStudentAvaliaMt
                      buttonRelatorio={this.buttonRelatorio}
                      setBoletimData={this.setBoletimData}
                    />
                    {filtrosRelatorios.fecth && (
                      <>
                        {isLoading ? (
                          <div
                            style={{
                              width: '100%',
                              height: `100%`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <img
                              src={get(this.props.theme, 'loadingGif')}
                              alt="loading"
                              style={{ height: '50px' }}
                            />
                          </div>
                        ) : (
                          <>
                            {boletimData && boletimData.NT_ALUNO ? (
                              <>
                                <div
                                  style={{
                                    background: '#bebebe',
                                    width: '100%',
                                    height: '1px',
                                    marginTop: '1rem'
                                  }}
                                />
                                {!isLoading &&
                                  get(periodoData, 'id') &&
                                  boletimData &&
                                  metadata && (
                                    <div
                                      style={{
                                        overflow: 'scroll',
                                        width: '100%'
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          marginLeft: '6rem'
                                        }}
                                      >
                                        <StackedAreaChart
                                          metadata={metadata}
                                          dataDot={boletimData}
                                          pontos={true}
                                          useBase={true}
                                          tipo={get(periodoData, 'id')}
                                          bottom={''}
                                          tourSelectorGrafico={'gráfico'}
                                          tourSelectorlegenda={'legenda'}
                                        />
                                        <LegendaStackedAreaGraph
                                          tipo={'estudante'}
                                        />
                                      </div>
                                    </div>
                                  )}
                                <div
                                  style={{
                                    marginTop: '2rem',
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <ParticipacaoDreColumn
                                    boletimaluno={boletimData}
                                  />
                                </div>
                              </>
                            ) : responseStatus === 403 ? (
                              <>
                                <BaseFiltroAvancadoItemStyleH1>
                                  <h1
                                    className="h3-style"
                                    style={{ fontSize: '25px' }}
                                  >
                                    Ops! Parece que você não tem permissão para
                                    visualizar esta página.
                                  </h1>
                                </BaseFiltroAvancadoItemStyleH1>
                                <img
                                  src={this.props.theme.erroImg}
                                  alt="waiting"
                                />
                                <button
                                  style={{
                                    color: 'white',
                                    width: '15%',
                                    backgroundColor: this.props.theme.primary,
                                    border: 'none',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    textAlign: 'center',
                                    borderRadius: '15px',
                                    boxShadow:
                                      '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                    padding: '4px 16px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}
                                  onClick={() =>
                                    setStateFilters({ fecth: true })
                                  }
                                >
                                  Voltar ao Relatório do Estudante
                                </button>
                              </>
                            ) : (
                              <div style={{ height: 'auto' }}>
                                <InsufficientData />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {filtrosRelatorios.fecthRelatorioHabilidade && (
                    <ReportStudentSkillLevel />
                  )}

                  {filtrosRelatorios.fecthRelatorioGeral && (
                    <GeneralStudentReport />
                  )}

                  {(filtrosRelatorios.fecth ||
                    filtrosRelatorios.fecthRelatorioHabilidade ||
                    filtrosRelatorios.fecthRelatorioGeral) && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '2rem 6rem 1rem 6rem'
                      }}
                    >
                      <button
                        className="button-primary"
                        style={{
                          color: 'white',
                          width: '30%',
                          border: 'none',
                          backgroundColor: this.props.theme.primary,
                          fontSize: '1rem',
                          fontWeight: '600',
                          textAlign: 'center',
                          borderRadius: '15px',
                          boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                          padding: '4px 16px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                        onClick={() =>
                          setStateFilters({
                            fecthRelatorioHabilidade: false,
                            fecth: true,
                            fecthRelatorioGeral: false
                          })
                        }
                      >
                        Relatório do Estudante
                      </button>

                      <GeneralStudentStyleButton>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end'
                          }}
                        >
                          <button
                            className="button-primary"
                            style={{
                              border: 'none',
                              fontSize: '1rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              borderRadius: '20px',
                              boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                              padding: '4px 16px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: '1rem'
                            }}
                            onClick={() =>
                              setStateFilters({
                                fecthRelatorioHabilidade: true,
                                fecth: false,
                                fecthRelatorioGeral: false
                              })
                            }
                          >
                            Relatório de Habilidade
                          </button>
                          <button
                            className="button-secondary"
                            style={{
                              border: 'none',
                              fontSize: '1rem',
                              fontWeight: '600',
                              borderRadius: '20px',
                              boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                              padding: '4px 16px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: '1rem'
                            }}
                            onClick={() =>
                              setStateFilters({
                                fecthRelatorioHabilidade: false,
                                fecth: false,
                                fecthRelatorioGeral: true
                              })
                            }
                          >
                            Visão Geral
                          </button>
                        </div>
                      </GeneralStudentStyleButton>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

ReportStudentAnalysis.contextType = FilterRelatorioContext;

export default withTheme(ReportStudentAnalysis);
